export const GET_ORDER_DETAIL = 'GET_ORDER_DETAIL'
export const SAVE_ORDER_DETAIL = 'SAVE_ORDER_DETAIL'
export const SAVE_DATA_BS_MYP_05_040 = 'SAVE_DATA_BS_MYP_05_040'
export const SAVE_RESERVE_STOCK = 'SAVE_RESERVE_STOCK'
export const SAVE_AVAILABLE_STOCK = 'SAVE_AVAILABLE_STOCK'
export const DELETE_AVAILABLE_STOCK = 'DELETE_AVAILABLE_STOCK'
export const SAVE_CANCEL_NO = 'SAVE_CANCEL_NO'

import {
  SET_ORDER,
  SET_DATA_BS_MYP_05_040,
  SET_CANCEL_NO
} from '@/store/modules/order/mutations'


import OrderApi from '../../../apis/order'

export default {
  // eslint-disable-next-line no-unused-vars
  [GET_ORDER_DETAIL]({ commit }, acptNo) {
    return  OrderApi.getOrderDetail(acptNo)
  },
  [SAVE_ORDER_DETAIL]({ commit }, data) {
    commit(SET_ORDER, data)
  },
  [SAVE_DATA_BS_MYP_05_040]({ commit }, data) {
    commit(SET_DATA_BS_MYP_05_040, data)
  },
  [SAVE_RESERVE_STOCK] (data) {
    return OrderApi.updateReserveStock(data)
  },
  // eslint-disable-next-line no-unused-vars
  async [SAVE_AVAILABLE_STOCK] ({ commit }, data) {
    const menuNo = data.menuNo
    const roomId = data.roomId
    if (data.menuNo) {
      delete data.menuNo
    }
    if (data.roomId) {
      delete data.roomId
    }
    return await OrderApi.updateAvailableStock(menuNo, roomId, data)
  },
  async [DELETE_AVAILABLE_STOCK] ({ commit }, data) {
    const menuNo = data.menuNo
    const roomId = data.roomId
    const reserveId = data.reserveId

    return await OrderApi.deleteAvailableStock(menuNo, roomId, reserveId)
  },
  [SAVE_CANCEL_NO]({ commit }, data) {
    commit(SET_CANCEL_NO, data)
  }
}

